/**
 * Emit hosts for the `form-fill` analytics group — 4 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { SegmentActionName, SegmentObjectName } from '@/models/analytics/segment-names';
import { ScreenName } from '@heidi/runtime/analytics-vocabulary';
import { trackScreenViewed } from './ui';

export function trackFormFillCreateTemplateClicked() {
  trackLegacyEvent({
    name: SegmentObjectName.FormFill,
    props: {
      action: SegmentActionName.FormFillCreateTemplateClicked,
    },
  });
}

export function trackFormFillHelpArticleClicked() {
  trackLegacyEvent({
    name: SegmentObjectName.FormFill,
    props: {
      action: SegmentActionName.FormFillHelpArticleClicked,
    },
  });

  // V2 — Amplitude migration
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.HelpViewed,
    props: {},
  });
}

export function trackFormFillUploadClicked() {
  trackLegacyEvent({
    name: SegmentObjectName.FormFill,
    props: {
      action: SegmentActionName.FormFillUploadClicked,
    },
  });
}

export function trackFormLibraryViewed() {
  trackScreenViewed({
    screen_name: ScreenName.FormLibrary,
  });
}
